<template>
    <div class="index-container">
        <div class="inner-wrapper">
            <div class="title" />
            <div class="desc">我们将根据您的信用 不定期为您提额</div>
            <div :class="['plan-container', showNewScore ? 'newScore' : 'oldScore']"></div>
            <div class="mark">提额金额以实际审核为准，请留意您的额度变化</div>
        </div>
    </div>
</template>

<script>
import appBridge from '@/common/util/appBridge';
import planMixin from '@/common/js/mixin';

export default {
    name: 'growth-plan-index',
    mixins: [planMixin],
    data() {
        return {
            showNewScore: false,
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: '额度成长计划',
                    color: '#002A3C',
                    fontType: '1',
                    fontSize: '18'
                },
                rightView: []
            }
        };
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
            appBridge.closePullToRefresh();
        }
        this.isShootNewScore();
    },
    mounted() {
        let score = localStorage.getItem('KUserTotalScore');
        this.POINT('h5_element_imp', {
            page: 'super-等级权益-额度成长计划详情页',
            tgt_event_id: 'h5_ACT_grade_limit',
            tgt_name: 'h5-ACT-等级权益-额度成长计划详情页',
            param: `'当前活力值：'${score ? score : '0未激活'}`
        });
    },
    methods: {
        async isShootNewScore() {
            const { Result, Content } = await this.$http.isShootNewScore({});
            if (Result === 200) {
                this.showNewScore = Content;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.index-container {
    width: 100%;
    min-height: 100vh;
    background: white;
    font-family: fzlt;
    .inner-wrapper {
        width: 100%;
        min-height: 100vh;
        background: url('../../../../assets/img/growth-plan-bg.png') no-repeat;
        background-size: 100% auto;
        padding-top: 59px;
        .title {
            width: 331px;
            height: 32px;
            margin: 0 auto;
            background: url('../../../../assets/img/growth-plan-header.png') no-repeat;
            background-size: 100% auto;
        }
        .desc {
            margin-top: 9px;
            font-size: 14px;
            font-family: fzlt_bold;
            font-weight: normal;
            color: #ffffff;
            line-height: 14px;
            text-align: center;
        }
        .plan-container {
            margin: 40px auto 24px auto;
            width: 339px;
            height: 340px;
            background-size: 100% 100%;
        }
        .newScore {
            background-image: url('../../../../assets/growth4.0/growth-plan-ic@2x.png');
        }
        .oldScore {
            background-image: url('../../../../assets/growth4.0/growth-plan-oldIc@2x.png');
        }
        .mark {
            font-size: 13px;
            font-weight: normal;
            color: #637388;
            line-height: 20px;
            text-align: center;
        }
    }
}
</style>
